<template>
    <div class="login-common">
        <div class="warp-login" @keyup.enter="goHome">
            <img class="logo-img"  src="@/assets/img/login/logo.jpg" alt="logo">
            <h3 class="text-center text_center">SIGN IN</h3>
            
            <div class="form-group">
                <p class="title">USERNAME</p>
                <input v-model="username" v-focus type="text" class="input-form-login username" placeholder="USERNAME">
            </div>
            <div class="form-group">
                <p class="title">PASSWORD</p>
                <input v-model="password"  type="password" class="input-form-login password" placeholder="PASSWORD" auto-complete="new-password">
            </div>
            <div class="text-center" v-if="isShowCaptcha">
                <canvas width="220" height="60" id="captcha"></canvas>
            </div>
            <p v-if="isShow" class="errorText">{{errorText}}</p>
            <div class="text-center text_center">
                <button class="btn-signin" @click="goHome">SIGN IN</button>
            </div>
        </div>
    </div>
</template>

<script>
import devConfig from '@/devConfig'
import fhMenu from '@/fhMenu'
import { sha256 } from 'js-sha256';
import Captcha from './captcha'
export default {
    directives: {
        focus: {
            // 指令的定义
            inserted: function (el) {
            el.focus()
            }
        }
    },
    data() {
        return {
            username: "",
            password: "",
            errorText:"",
            isShow:false,
            captchaVal:'nE7jAp5m',
            isShowCaptcha:false
        }
    },
    created(){
        this.getCaptcha()
    },
    mounted: function () {
        this.$nextTick(function () {
            this.getCaptcha()
        })
    },
    methods: {
        getCaptcha(){
            axios.post('/JSONAPI',{
                cmdType:'GET_TRUE_CAPTCHA',
            })
            .then((response) =>{
                if(response.data.ret == 0)
                {
                    this.isShowCaptcha = !response.data.isWAN // WAN 侧访问不显示验证码
                    setCaptcha(response.data.captcha)
                }
            })
        },
        goHome () {
            this.isShow = false;
            if(this.username === "" || this.password === "")
            {
                this.isShow = true
                this.errorText = "The name or password can not empty!"
                return
            }

            axios.post('/JSONAPI',{
                cmdType:'SET_WEB_LOGIN',
                username:this.username,
                password:sha256.hmac('fiberhome',this.password)
            })
            .then((response) =>{
                if(response.data.ret != 0)
                {
                    this.loginError(response.data)
                }
                else
                {
                    if(process.env.NODE_ENV !== 'production')
                    {
                        cookie.clear()
                        cookie.setItem('userType', response.data.userType + '')
                        cookie.setItem('username', response.data.username)
                        cookie.setItem('uuid', response.data.uuid)
                    }
                    

                    // 更新设备能力集 用户
                    let config = devConfig.getData()
                    config.userType = response.data.userType
                    devConfig.update(config)

                    // 初始化菜单
                    fhMenu.init()
                    
                    // 跳转到首页
                    this.$router.push('/home')
                    
                    
                }
            })
            .catch( (error) =>{
                this.$message.error("Error! please check network connection.")
            })
        },
        loginError(data) {

            this.isShow = true

            if(data.errCode === 3)
            {
                this.errorText = `Login failed,the user have logined.please wait for ${data.waitTime} seconds!`
            }
            else if(data.errCode === 4)
            {
                this.errorText = "Login error! You do not have permission to login."
            }
            else if(data.errCode === 7)
            {
                this.errorText = `Sorry,you have tried more than 3 times, Please try again after ${data.waitTime / 60} minute.`
            }
            else if(data.errCode === 8)
            {
                this.errorText = "Login error! Please modify the default password and try again."
            }
            else
            {
                this.errorText = "The name or password is wrong!"
            }
        }
    }
}

function setCaptcha(val) {
    let captchaVal = val || 'nE7jAp5m'
    let captcha1 = new Captcha({
        fontSize:35,
        content:captchaVal,
        backGroundColor:[232, 240, 254],
        length: captchaVal.length + 1
    });
    captcha1.draw(document.querySelector('#captcha'))
}
</script>


<style src="@/assets/style/index.css"></style>
<style src="@/assets/style/login.scss" lang="scss"></style>
